import NewFrom from "csi/table/NewFrom";
import declare from "dojo/_base/declare";

const NewStyleBOMFromThemeBOMController = declare(NewFrom, {

	/**
     * @override
     * populate ApparelBOMForm disableSubtype property - set to true as the new ApparelBOM will be linked to the ThemeBOM 
     */
	onCreatePopupParams: function(params) {
		params.disableSubtype = true;
	},
	
});

export = NewStyleBOMFromThemeBOMController;
